import { VehiclePlan } from '../types';
import { getMileagePackageCopy } from '../utils/get-mileage-package-copy';
import { cn } from '@/shadcn-ui/utils';

interface MileagePackageHiddenInputProps {
  vehiclePlans: VehiclePlan[];
  currentPlanMiles: number;
  variant?: 'gray-rounded';
}

export default function MileagePackageHiddenInput({
  currentPlanMiles,
  vehiclePlans,
  variant,
}: MileagePackageHiddenInputProps) {
  const vehiclePlan = vehiclePlans.find(
    (plan) => plan.miles_per_month === currentPlanMiles
  );
  const vehiclePlanCopy = vehiclePlan
    ? getMileagePackageCopy({ plan: vehiclePlan })
    : undefined;

  return (
    <div
      className={cn('flex flex-col gap-2 rounded-md p-4 ring-flexcar-neutral80', {
        'rounded-[16px]': variant === 'gray-rounded',
        'bg-flexcar-neutral90': variant === 'gray-rounded',
        'ring-2': variant !== 'gray-rounded',
      })}
    >
      <div className="flex flex-row justify-between">
        <div className="flex flex-row items-center justify-center gap-3">
          <input hidden={true} readOnly={true} name="plan" value={vehiclePlan?.id} />
          <p className="body-strong">{vehiclePlanCopy?.planName}</p>
        </div>

        <p className="body">{vehiclePlanCopy?.monthlyCostCopy}</p>
      </div>

      <div className="flex flex-row justify-end">
        <div className="text-right text-xs font-medium text-flexcar-neutral50">
          <p className="sub">{vehiclePlanCopy?.mileageIncludedCopy}</p>

          {vehiclePlanCopy?.commuterCopy ? (
            <p className="sub">{vehiclePlanCopy?.commuterCopy}</p>
          ) : null}

          <p className="sub">{vehiclePlanCopy?.overageCopy}</p>
        </div>
      </div>
    </div>
  );
}
